import { forwardRef } from 'react'
import cn from 'clsx'

import { IMAGE_RESIZE_SPEC } from '@core/image'
import { buttonClassNames, ResponsiveImage } from '@ds/components'

import promoPreview from './assets/analytics-performance-widget.png'
import styles from './InsightsPromoBanner.module.css'

export type TInsightsPromoBannerProps = {
    title: string
    description: string
    ctaLabel: string
    ctaHref: string
    imageAlt: string
    onCtaClick: () => void
    variant?: 'rounded' | 'flush'
}

export const InsightsPromoBanner = forwardRef<HTMLElement, TInsightsPromoBannerProps>(
    ({ title, description, ctaLabel, ctaHref, imageAlt, onCtaClick, variant = 'rounded' }, ref) => (
        <section ref={ref} className={styles.banner} data-variant={variant}>
            <div className={styles.inner}>
                <div className={styles.info}>
                    <h2 className={styles.title}>{title}</h2>
                    <p className={styles.description}>{description}</p>
                    <a
                        href={ctaHref}
                        onClick={onCtaClick}
                        className={cn(
                            buttonClassNames({ variant: 'primary', size: 'small' }),
                            styles.cta,
                        )}
                    >
                        {ctaLabel}
                    </a>
                </div>
                <div className={styles.preview}>
                    <ResponsiveImage
                        src={promoPreview}
                        width={914}
                        height={367}
                        alt={imageAlt}
                        sizes="(max-width: 767px) calc(100vw - 32px), (max-width: 1279px) 48vw, 640px"
                        className={styles.previewImage}
                        resize={IMAGE_RESIZE_SPEC}
                    />
                </div>
            </div>
        </section>
    ),
)
